import { set } from 'lodash';

import { TCardLinkType } from 'modules/customer/domain/entities';
import { IContractPaymentsRepository } from 'modules/customer/domain/repositories';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';
import { PAYMENT_METHOD_TO_API } from 'shared/infra/adapters';

type TCreateParams = Parameters<IContractPaymentsRepository['create']>[0];

const CARD_LINK_TO_API: Record<TCardLinkType, string> = {
  MAIN: 'PRINCIPAL',
  SECONDARY: 'SECUNDARIO',
};

export default class VectisContractPaymentsRepository
  implements IContractPaymentsRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public create: IContractPaymentsRepository['create'] = async params => {
    const url = params.process.endpoint;
    const processBody = params.process.body;
    const methodBody = this.getCreateUniqueMethodBody(params);

    const { pix } = await this.httpProvider.post<{
      pix?: { id: number; linhaDigitavel: string };
    }>(url, {
      ...processBody,
      ...methodBody,
    });

    return {
      pix: pix
        ? {
            code: pix.linhaDigitavel,
            id: pix.id,
          }
        : undefined,
    };
  };

  private getCreateUniqueMethodBody(params: TCreateParams) {
    if (params.method === 'PIX') {
      return {
        formaPagamento: PAYMENT_METHOD_TO_API.PIX,
      };
    }

    const formaPagamento =
      params.process.type === 'CONTRACT'
        ? PAYMENT_METHOD_TO_API.CREDIT_CARD
        : PAYMENT_METHOD_TO_API.RECURRING_CARD;

    const body =
      'id' in params.card
        ? {
            perfilPagamento: {
              idMetodoPagamento: params.card.id,
              numeroParcelas: params.card.installments,
            },
          }
        : {
            perfilPagamento: {
              nomeImpressoCartao: params.card.name,
              dataValidade: params.card.expiry,
              numeroCartao: params.card.number,
              codigoSeguranca: params.card.cvc,
              bandeira: params.card.flag,
              numeroParcelas: params.card.installments,
            },
          };

    if (params.process.type === 'CONTRACT') {
      set(body, 'perfilPagamento.formaPagamento', formaPagamento);
    } else {
      set(body, 'formaPagamento', formaPagamento);
    }

    if (params.link) {
      set(
        body,
        'tipoVinculoMetodoPagamento',
        CARD_LINK_TO_API[params.link.type],
      );
      set(body, 'aceiteVinculoMetodoPagamento', params.link.accepted);
      set(
        body,
        'textoAceiteVinculoMetodoPagamento',
        params.link.acceptanceText,
      );
    }

    return body;
  }
}
